import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const createShippingUser = createAction(ACTION.CREATE_SHIPPING_USER.REQUEST, data => data);
